<template>
    <div class="main">

        <Seo :title="$t('mainTitle')" canonical=""/>

        <!-- MAIN -->
        <div class="uk-grid-collapse uk-grid-match" uk-grid>
            <div class="uk-width-1-1 video-struct first-video">
                <div class="uk-cover-container uk-height-1-1 uk-animation-fade">
                    <video id="video-main" class="video-main"
                           muted
                           oncontextmenu="return false;" playsinline uk-cover="autoplay: inview">
                        <source :src="require('../assets/'+getMode+'/videos/main.mp4')" type="video/mp4">
                    </video>
                    <VideoLoop id="video-main"/>


                    <div v-if="getMode === 'cancelcancer'"
                         class="uk-position-center uk-text-center">

                        <SiteHeadline message="Website Relaunch am 15.02.2024"/>
                        <div class="uk-margin"/>

                        <div class="uk-grid-small uk-child-width-auto uk-flex uk-flex-center" uk-grid
                             uk-countdown="date: 2024-02-15T00:00:00+01:00">
                            <div>
                                <div class="uk-countdown-number uk-countdown-days"></div>
                                <div class="uk-countdown-label uk-margin-small uk-text-center ">Tage</div>
                            </div>
                            <div class="uk-countdown-separator">:</div>
                            <div>
                                <div class="uk-countdown-number uk-countdown-hours"></div>
                                <div class="uk-countdown-label uk-margin-small uk-text-center ">Stunden
                                </div>
                            </div>
                            <div class="uk-countdown-separator">:</div>
                            <div>
                                <div class="uk-countdown-number uk-countdown-minutes"></div>
                                <div class="uk-countdown-label uk-margin-small uk-text-center ">Minuten
                                </div>
                            </div>
                            <div class="uk-countdown-separator">:</div>
                            <div>
                                <div class="uk-countdown-number uk-countdown-seconds"></div>
                                <div class="uk-countdown-label uk-margin-small uk-text-center">Sekunden
                                </div>
                            </div>
                        </div>

                        <div class="headline-item-distance"/>


                        <SiteHeadline is-main message="Für eine Kindheit ohne Krebs"
                                      has-button>
                            <Button text="Jetzt Kampagnenvideo ansehen" is-large is-min-width mode="default"
                                    uk-toggle="target: #modal-cancelcancer"/>
                        </SiteHeadline>


                        <VideoModal modal-id="modal-cancelcancer"
                                    video-src="https://www.youtube.com/watch?v=b2U7GiABi_A"/>
                    </div>

                    <div v-else class="uk-position-center uk-text-center"
                         :uk-scrollspy="getMode === 'filmpiraten' ? 'cls: uk-animation-fade; delay: 2000;':''">
                        <SiteHeadline is-main :headline="$t('mainHeadline')"
                                      :message="$t('mainMessage')"
                                      has-button>
                            <PromotionButtons/>
                        </SiteHeadline>
                    </div>


                    <div class="uk-position-bottom uk-text-center uk-margin-bottom next-item"
                         uk-scrollspy="cls: uk-animation-slide-top-small; delay: 1000;">
                        <a class="uk-link-muted uk-link-white" href="#features" uk-scroll="offset: 15">
                            <span uk-icon="icon: chevron-down; ratio: 2"></span>
                        </a>
                    </div>


                </div>
            </div>
        </div>
        <!-- /MAIN -->

        <!-- /FEATURES -->
        <span id="features"/>
        <FeaturesList v-if="getMode ==='camcore'" :features="getConfig.features" :headline="$t('companyPhilosophy')"
                      :message="$t('whyChooseX', {x: getConfig.name})"/>

        <div v-if="getMode ==='filmpiraten'" class="new-section-struct site-width single">
            <SiteHeadline :message="$t('inHouseHeadline')" has-button>

                <FeatureItem class="uk-text-left"
                             message="
                          Wir kreieren und produzieren Werbespots und Imagefilme, einfach jedwede Form von
                          Bewegtbild, die denkbar ist. Und das in bester Kinoqualität. Dank unserer Leidenschaft und vor allem
                          jahrelangen Erfahrung wissen wir, worauf es bei einem guten Film ankommt."/>

                <div class="block-button-distance uk-text-center uk-width-1-1">
                    <router-link :to="'/'+$i18n.locale+'/'+$t('contact').toLowerCase()">
                        <Button :text="$t('contact')" is-large is-min-width mode="success"/>
                    </router-link>
                    <div class="uk-margin-small-top">
                        {{ $t('freeOffer') }}
                    </div>
                </div>

            </SiteHeadline>
        </div>

        <div v-if="getMode ==='cancelcancer'" class="new-section-struct site-width ">
            <SiteHeadline message="Botschafter*innen" has-button>

                <div class="headline-item-distance"/>

                <img class="uk-visible@m" alt="Supporter" src="../assets/cancelcancer/supporter.png" uk-img>
                <img class="uk-hidden@m" alt="Supporter" src="../assets/cancelcancer/supporterm.png" uk-img>

            </SiteHeadline>
        </div>

        <!-- /FEATURES -->

        <!-- SHOWREEL -->
        <span id="showreel" v-if="getConfig.showreel">
            <div class="uk-grid-collapse video-struct uk-grid-match" uk-grid>
                <div class="uk-width-1-1 uk-height-viewport">
                    <div class="uk-cover-container uk-height-1-1 uk-animation-fade">
                        <video id="video-showreel" class="video-showreel"
                               muted
                               oncontextmenu="return false;" playsinline uk-cover="autoplay: inview">
                            <source :src="require('../assets/'+getMode+'/videos/showreel.mp4')" type="video/mp4">
                        </video>
                        <VideoLoop id="video-showreel"/>

                        <div class="uk-position-center uk-text-center">
                            <SiteHeadline
                                :headline="$t('showreel')"
                                :message="$t('showreelMessage')"
                                has-button
                                uk-scrollspy="cls: uk-animation-slide-bottom-small; delay: 200">
                                <a href="#showreel">
                                <Button :text="$t('watch')" is-large is-min-width mode="default"
                                        uk-toggle="target: #modal-showreel"/>
                                    </a>
                            </SiteHeadline>
                        </div>
                    </div>
                </div>
            </div>
        </span>

        <VideoModal v-if="getConfig.showreel" modal-id="modal-showreel"
                    :video-src="getConfig.showreel"/>
        <!-- /SHOWREEL -->


        <!-- REFERENCES -->
        <VideoList v-if="videos && videos.length>0" :headline="$t('references')" :message="$t('videoListMessage')"
                   :videos="videos"/>
        <!-- /REFERENCES -->

        <!-- AWARD -->
        <AwardList v-if="getConfig.awards && getConfig.awards.length>0" :awards="getConfig.awards"
                   :headline="$t('awards.message')" :message="$t('awards')"
                   class="new-section-struct block-struct-background"
                   switch-headline/>
        <!-- /AWARD -->

        <!-- CUSTOMERS -->
        <CustomersList v-if="customers && customers.length>0" :customers="customers" :headline="$t('customersMessage')"
                       switch-headline
                       :message="$t('customersHeadline')" class="new-section-struct"/>
        <!-- /CUSTOMERS -->

        <NumberReferences v-if="false" class="site-width new-section-struct"/>

        <LastHeadlineButton v-if="getConfig.buttons && getConfig.buttons.length>0"
                            :headline="$t('weHaveTheRightThingForYou')" is-large>
            <PromotionButtons/>
        </LastHeadlineButton>
        <div v-if="getConfig.buttons && getConfig.buttons.length>0" class="last-button-distance"/>


        <div v-if="getMode==='cancelcancer'" class="site-width">

            <EmailContact/>

            <div class="section-distance"/>
            <TelephoneContact/>

            <div class="section-distance"/>
            <SiteHeadline message="Standort"/>
            <div class="headline-item-distance"/>


            <div
                class="uk-card uk-card-alternative uk-dark-card-hovered uk-padding uk-text-center site-width single">
                <div class="available-number uk-grid-collapse uk-flex-center uk-grid-match uk-flex uk-flex-middle"
                     uk-grid>


                    <div v-for="location in getConfig.locations" :key="location.name"
                         class="uk-width-1-1">

                        <div class="uk-text-center">
                            <img :alt="location.name+' Logo'" :src="require('../assets/images/'+(location.logo))"
                                 class="city-logo"
                                 uk-img/>

                            <div class="location-name">{{ location.name }}</div>
                            <div :uk-tooltip="'title:'+$t('copyToClipboard')"
                                 class="cursor-pointer"
                                 v-on:click="$copyText(location.contact + ' '+ location.street + ' ' + location.zip + ' ' + location.city)">
                                <div class="location-address name">{{ location.contact }}</div>
                                <div class="location-address">{{ location.street }}</div>
                                <div class="location-address">{{ location.zip }} {{ location.city }}</div>
                            </div>

                            <span v-if="false">
                        <span v-for="contact in location.contacts" :key="contact.val">
                            <div
                                class="uk-margin-medium-top uk-grid-collapse uk-flex-center uk-grid-match uk-flex uk-flex-middle"
                                uk-grid>
                                <div>
                                    <a :href="contact.type+':'+(($t(contact.val)).trim())">
                                        <span :uk-icon="'icon:'+contact.icon+'; ratio: 1.3'"></span>
                                    </a>
                                </div>
                                <div>
                                    <a :href="contact.type+':'+(($t(contact.val)).trim())" class="padding-left-small">
                                        <span class="location-address padding-left-small">{{ $t(contact.val) }}</span>
                                    </a>
                                </div>
                            </div>
                            <a :href="contact.type+':'+(($t(contact.val)).trim())"
                               class="uk-button uk-button-default address-button">
                                {{ $t(contact.buttonMessage) }}
                            </a>

                            <div class="respond-info">
                                <span v-if="contact.type ==='tel'">
                                    <TelephoneInformation/>
                                </span>
                                <span v-else>
                                    {{ $t('weWillRespondShortly') }}
                                </span>
                            </div>

                        </span>

                        <div class="available-info">
                            {{ $t('monday') }} {{ $t('to') }} {{ $t('friday') }}<br/>
                            {{ $t('availableTimeMessage') }}
                        </div>
                              </span>


                        </div>
                    </div>
                </div>
            </div>

            <div class="last-button-distance"/>
        </div>


    </div>
</template>


<script>

import SiteHeadline from "../components/SiteHeadline";
import VideoModal from "../components/VideoModal";
import Seo from "../components/Seo";
import LastHeadlineButton from "../components/LastHeadlineButton";
import UIkit from "uikit";
import FeaturesList from "../components/FeaturesList";
import CustomersList from "../components/CustomersList";
import VideoList from "@/components/VideoList";
import Button from "@/components/Button";
import axios from "axios";
import NumberReferences from "@/components/NumberReferences";
import PromotionButtons from "@/components/PromotionButtons";
import VideoLoop from "@/components/VideoLoop";
import AwardList from "@/components/AwardList";
import FeatureItem from "@/components/FeatureItem.vue";
import TelephoneInformation from "@/components/TelephoneInformation.vue";
import EmailContact from "@/components/EmailContact.vue";
import TelephoneContact from "@/components/TelephoneContact.vue";

export default {
    name: 'Main',
    components: {
        TelephoneContact,
        EmailContact,
        TelephoneInformation,
        FeatureItem,
        AwardList,
        VideoLoop,
        PromotionButtons,
        NumberReferences,
        Button,
        VideoList,
        CustomersList,
        FeaturesList,
        LastHeadlineButton,
        Seo,
        VideoModal,
        SiteHeadline
    },
    data() {
        return {
            publicPath: process.env.BASE_URL,

            videos: [],
            customers: [],
        };
    },
    computed: {
        trimmedFeatures() {
            let features = this.features;
            let filtered = features.filter(function (el) {
                if (el.title) return el;
            });

            return filtered;
        },
    },
    mounted() {
        let hashtag = location.hash;
        if (hashtag && hashtag === '#showreel') {
            setTimeout(function () {
                UIkit.scroll(hashtag).scrollTo(hashtag);
            }, 50);
        }
    },
    created() {
        if (this.getMode === 'cancelcancer') {
            return;
        }

        this.getFavoriteReferences();
        this.getCustomers();
    },
    methods: {
        getCustomers() {
            let http = axios.create({
                timeout: this.$store.state.apiTimeout,
            });

            http.get(this.getBaseUrl + '/api/customers').then(response => {
                this.customers = response.data;

            }).catch(() => {
            });
        },
        getFavoriteReferences() {
            let http = axios.create();

            http.get(this.getBaseUrl + '/api/references/favorites').then(response => {
                this.videos = response.data;

            }).catch(() => {

            });
        },
    }
}
</script>


<style lang="scss" scoped>

.video-main {
    opacity: 0.55;
}

.video-showreel {
    opacity: 0.6;
}

.section-headline-distance {
    margin-top: 80px;
}

.block-button-distance {
    margin-top: 50px;

    &.additional-distance {
        margin-top: 100px;
    }
}

.block-headline-distance {
    margin-bottom: 80px;
}

.text-button-distance {
    margin-top: 100px;
}

.title-distance {
    margin-top: 120px;
}

.view-distance {
    height: 12px;
}

.uk-card-dark {
    background: $alternative-color;
    color: #fff;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
}

.uk-width-very-small {
    width: 70px;
}

#features {
    padding-top: -70px;
}


.city-logo {
    max-height: 130px;
}

.location-address {
    color: #f2f2ff;
    opacity: 0.9;
    line-height: 1.4;
    letter-spacing: .007em;
    font-size: 18px;

    &.name {
        font-size: 22px;
        font-weight: 500;
    }
}

.available-info {
    margin-top: 10px;
    font-size: 15px;
}

.location-name {
    line-height: 1.0625;
    font-weight: 500;
    letter-spacing: -.009em;
    margin-top: 15px !important;
    margin-bottom: 20px !important;
    font-size: 22px;
}

.address-button {
    margin-top: 10px;
    font-size: 16px !important;
    font-weight: 500 !important;
    min-width: 190px;
}

</style>
